/* libs */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { arrayMove } from "react-sortable-hoc";

/*component */
import ExperienceInputs from "./ExperienceInputs";
import SortableGrid from "../../../shared/SortableGrid";
import CollectionAccordion from "../../../shared/Forms/CollectionAccordion";

class Experiences extends Component {
	constructor(props) {
		super(props);
		this.state = {
			count: 0,
			shouldDisable: false,
			expandedIndex: null,
			initialLoad: false,
		};
	}

	componentDidUpdate(prevProps) {
		if (this.props.values !== prevProps.values && this.props.values.experiences && !this.state.initialLoad) {
			const { experiences } = this.props.values;
			this.setState({
				count: experiences.length,
				initialLoad: true,
			});
		}
	}

	getOptionsShown = shown => {
		if (shown) {
			this.setState({
				shouldDisable: true,
			});
		} else {
			this.setState({
				shouldDisable: false,
			});
		}
	};

	toggleCollectionItem = index => {
		const { expandedIndex } = this.state;
		if (expandedIndex === index) {
			this.setState({
				expandedIndex: null,
			});
		} else {
			this.setState({
				expandedIndex: index,
			});
		}
	};

	onSortEnd = ({ oldIndex, newIndex }) => {
		const { values, formApi } = this.props;
		if (values && values.experiences) {
			const { setValues } = formApi;
			const { experiences } = values;
			setValues({
				...values,
				experiences: arrayMove(experiences, oldIndex, newIndex),
			});
		}
	};

	addExperience = () => {
		const { count } = this.state;
		this.setState({
			count: count + 1,
			expandedIndex: count,
		});
	};

	deleteExperience = index => {
		const { values, formApi } = this.props;
		const { count } = this.state;
		if (values && values.experiences) {
			const { setValues } = formApi;
			const { experiences } = values;
			this.setState(
				{
					count: count - 1,
				},
				setValues({
					...values,
					experiences: [...experiences.slice(0, index), ...experiences.slice(index + 1)],
				})
			);
		} else if (count > 0) {
			this.setState({
				count: count - 1,
			});
		}
	};

	copyExperience = index => {
		const { values, formApi } = this.props;
		const { count } = this.state;
		if (values && values.experiences) {
			const { setValues } = formApi;
			const { experiences } = values;
			this.setState(
				{
					count: count + 1,
				},
				setValues({
					...values,
					experiences: [...experiences, experiences[index]],
				})
			);
		}
	};

	renderExperiences = () => {
		const { experiences, values } = this.props;
		const { count, expandedIndex } = this.state;
		const value = values && values.experiences ? values.experiences : [];
		let experienceElements = [];
		for (var i = 0; i < count; i++) {
			const title = value[i] ? value[i].title : "";
			experienceElements.push(
				<CollectionAccordion
					key={i}
					title={title}
					expanded={expandedIndex === i}
					index={i}
					copyCollection={this.copyExperience}
					deleteCollection={this.deleteExperience}
					toggleCollectionItem={this.toggleCollectionItem}
					getOptionsShown={this.getOptionsShown}
				>
					<ExperienceInputs experiences={experiences} index={i} />
				</CollectionAccordion>
			);
		}
		return experienceElements;
	};

	render() {
		const { shouldDisable } = this.state;

		return (
			<div>
				<SortableGrid
					shouldDisable={shouldDisable}
					onSortEnd={this.onSortEnd}
					createNew={this.addExperience}
					title="Experiences"
				>
					{this.renderExperiences()}
				</SortableGrid>
			</div>
		);
	}
}

Experiences.propTypes = {
	values: PropTypes.object,
	formApi: PropTypes.object,
	experiences: PropTypes.array,
};

export default Experiences;
